const repairList = {
  repairList: "Lista de Registros de Reparaciones",
  search: "Buscar",
  equipmentTag: "TAG del Equipo",
  customer: "Cliente",
  repairDate: "Fecha de Reparación",
  wasReplaced: "fue reemplazado",
  addSparePart: "Agregar Consumible",
  lastChangeWas: "El último cambio fue el",
  itHasToBe: "Debe cambiarse cada",
  nextChange: "El siguiente cambio debe ser el",
  changeOrEdit: "Cambia o edita el elemento",
  deletePart: "Elimina el elemento",
  createReapirLog: "Crear registro de reparación",
  type: "Tipo",
  consumable: "Consumible",
  log: "Registro",
  itemsPerPage: "Filas por página",
  itemsPerPageAllText: "Todas",
  CREATED: "CREADO",
  REPAIR: "REPARACIÓN",
  UPDATE: "ACTUALIZACIÓN",
  year: "año",
  years: "años",
  month: "mes",
  months: "meses",
  week: "semana",
  weeks: "semanas",
  day: "día",
  days: "días",
  hour: "hora",
  hours: "horas",
  minute: "minuto",
  minutes: "minutos",
  second: "segundo",
  seconds: "segundos",
  headers: {
    taskName: "Nombre de la Tarea",
    taskDescription: "Descripción",
    taskDate: "Fecha de la Tarea"
  }
};
export default repairList;
